import { render, staticRenderFns } from "./mapkind-panel.vue?vue&type=template&id=5daddc82"
import script from "./mapkind-panel.vue?vue&type=script&lang=js"
export * from "./mapkind-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5daddc82')) {
      api.createRecord('5daddc82', component.options)
    } else {
      api.reload('5daddc82', component.options)
    }
    module.hot.accept("./mapkind-panel.vue?vue&type=template&id=5daddc82", function () {
      api.rerender('5daddc82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mutils/views/map-save-action/mapkind-panel.vue"
export default component.exports